import { lazy } from '@loadable/component';

const BookingDetails = lazy(() =>
  import(
    /* webpackChunkName: "booking_details" */
    './booking_details'
  )
);

export default BookingDetails;
